import axios from 'axios';


const Server = "http://167.86.98.171:6001/api/"//"http://localhost:54062//api/"//

export const Routes = {
    //Login Request
    Login: 'Account/login',

    //Roles
    GetAllRoles: 'Account/GetAllRoles',

    //Statistics
    Get7DayStatistics: 'SimpleClickable/GetQuestionsStatistics_7DAY',
    GetTopicStatistics: 'SimpleClickable/GetQuestionsStatistics_TOPIC',
    DetailedStatisticsQuestion: 'Statistics/DetailedStatisticsQuestion',
    
    //Data Pools
    GetDataPools: 'DataPools/GetDataPools',
    GetDataPoolsAdmin: 'DataPools/GetDataPoolsAdmin',
    AddDataPool: 'DataPools/AddDataPool',
    EditDataPool: 'DataPools/EditDataPool',
    GetDataPoolTopics: 'DataPools/GetDataPoolTopics',
    AdvancedDataPoolStatistics: 'DataPools/AdvancedDataPoolStatistics',
    
    //Information
    AddInformation: 'Information/AddInfo',
    DeleteInformation: 'Information/DeleteInfo',
    EditCodeInformation: 'Information/EditCode',
    EditLatexInformation: 'Information/EditLatex',
    EditPDFInformation: 'Information/EditPDF',
    RemovePDFInformation: 'Information/RemovePDF',
    SearchInformation_ADVANCED_PORTAL: 'Information/SearchInformation_ADVANCED_PORTAL',
    SearchOwnedInformation_ADVANCED_PORTAL: 'Information/SearchOwnedInformation_ADVANCED_PORTAL',
    SearchInformationQuestions_ADVANCED_PORTAL: 'Information/SearchInformationQuestions_ADVANCED_PORTAL',
    GetInformationById: 'Information/GetInformationId',
    AssignQuestionsToInformation: 'Information/AssignQuestions',
    DeassignQuestionsToInformation: 'Information/DeassignQuestions',
   
    AddBackgroundImage: 'BackgroundImage/AddImage',
    EditBackgroundImageCode: 'BackgroundImage/EditCode',
    EditBackgroundImageImage: 'BackgroundImage/EditImage',
    SearchBackgroundImage_ADVANCED_PORTAL: 'BackgroundImage/SearchBackgroundImage_ADVANCED_PORTAL',
    GetBackgroundImageById: 'BackgroundImage/GetById',
    SelectBackgroundImageElements: 'BackgroundImage/SelectImageGroup',

    AddCourseMapElementImages: 'CourseMapElementImages/AddImage',
    EditCourseMapElementImagesCode: 'CourseMapElementImages/EditCode',
    EditCourseMapElementImagesImage: 'CourseMapElementImages/EditImage',
    SearchCourseMapElementImages_ADVANCED_PORTAL: 'CourseMapElementImages/SearchCourseMapElementImages_ADVANCED_PORTAL',
    GetCourseMapElementImagesById: 'CourseMapElementImages/GetById',
    SelectCourseMapElementImagesId: 'CourseMapElementImages/SelectImage',
    SelectImageElementGroup: 'CourseMapElementImages/SelectImageGroup',

    //Get All Users
    GetAllUsers: 'Account/GetAllUsers',
    GetAllUsers_LIMITED: 'Account/GetAllUsers_PORTAL_LIMITED',
    GetUser: 'Account/GetUserByName',
    AddUser:'Account/AddUser',
    GetToBeAssignedProfessors:'Account/GetToBeAssignedProfessors',
    EditUsername:'Account/EditUsername',
    EditUserNameEmail:'Account/EditNameEmail',
    RemoveUserProfilePicture:'Account/RemoveProfilePicture',
    UpdateUserProfilePicture:'Account/UpdateProfilePicture',
    EditRoles:'Account/EditRoles',

    //Levels Of Difficulty
    GetLevelsOfDifficulty:'LevelsOfDifficulty/GetLevelsOfDifficulty',
    GetLevelsOfDifficulty_EXTENDED:'LevelsOfDifficulty/GetLevelsOfDifficulty_PORTAL_EXTENDED_DETAILS',
    AddLevelOfDifficulty:'LevelsOfDifficulty/AddLevel',
    EditLevelOfDifficulty:'LevelsOfDifficulty/EditLevel',
    DeleteLevelOfDifficulty:'LevelsOfDifficulty/DeleteLevel',

    //Courses
    GetAllCourses: 'Course/GetAllCourses_PORTAL',
    GetAllMyCourses: 'Course/GetAllMyCourses_PORTAL',
    SearchCourses: 'Course/SearchCourses_PORTAL',
    GetCourseById: 'Course/GetCourseById_PORTAL',
    SearchCourseMaps: 'CourseMap/SearchCourseMap_ADVANCED_PORTAL',
    SearchOwnedCourseMaps: 'CourseMap/SearchOwnedCourseMap_ADVANCED_PORTAL',
    EditMapBasicInfo: 'CourseMap/EditMapBasicInfo',
    DeleteMapElement: 'CourseMap/DeleteElement',
    DeleteElementSeries: 'CourseMap/DeleteElementSeries',
    SetElementSeries: 'CourseMap/SetElementSeries',
    AddMapElements: 'CourseMap/AddMapElements',
    AddEditElementPDF: 'CourseMap/AddEditElementPDF',
    RemoveElementPDF: 'CourseMap/RemoveElementPDF',
    AddEditElementVideo: 'CourseMap/AddEditElementVideo',
    RemoveElementVideo: 'CourseMap/RemoveElementVideo',
    DeleteElementBackgroundImage: 'CourseMap/DeleteElementBackgroundImage',
    EditMapElementBasicInfo: 'CourseMap/EditMapElementBasicInfo',
    GetMapSolutionKey: 'CourseMap/GetSolutionKey',
    CopyCourseMap: 'CourseMap/CopyMap',
    AddCourseMapArrows: 'CourseMap/AddArrows',
    AddCourseMapPDFStatistic: 'CourseMap/AddPDFStatistic',

    GetStudentCourseById: 'Course/GetCourseById_STUDENT_PORTAL',
    AddCourse:'Course/AddCourse',
    AddEditCourseThumbnail:'Course/AddEditCourseThumbnail',
    AssignProfessors:'Course/AssingLecturersToCourse',
    AddTutorialGroup:'Tutorials/AddGroup',
    AddCourseSingleStep:'Course/AddCourseSingleStep',
    EditCourseSingleStep:'Course/EditCourseSingleStep',
    GetCourseAdders: 'Course/GetCourseAdders_PORTAL',

    //Course Map
    GetCourseMapPlayById: 'CourseMap/GetCourseMapPlayById_PORTAL',
    GetCourseViewEditPlayById: 'CourseMap/GetCourseMapViewEditById_PORTAL',
    GetCourseTESTById: 'CourseMap/GetCourseMapTESTINFOREXAM_2021_09_2_ById_PORTAL',

    AddCourseMap: 'CourseMap/AddMap',
    DeleteCourseMap: 'CourseMap/DeleteMap',
    AddEditElementRelation: 'CourseMap/AddEditElementRelation',
    RemoveElementRelation: 'CourseMap/RemoveElementRelation',
    AddEditElementBadge: 'CourseMap/AddEditElementBadge',
    RemoveElementBadge: 'CourseMap/RemoveElementBadge',
    EditMapImage: 'CourseMap/EditMapImage',
    EditElementBadgePercentage: 'CourseMap/EditElementBadgePercentage',
    EditElementBadge: 'CourseMap/EditElementBadge',
    EditElementBadgeLocation: 'CourseMap/EditElementBadgeLocation',
    EditElementLocation: 'CourseMap/EditElementLocation',
    AddMapBadgeGroup: 'CourseMap/AddBadgeGroup',
    EditMapBadgeGroup: 'CourseMap/EditBadgeGroup',
    RemoveMapBadgeGroup: 'CourseMap/RemoveBadgeGroup',
    AddMapBadgeGroupEntities: 'CourseMap/AddBadgeGroupEntities',
    EditMapBadgeGroupEntity: 'CourseMap/EditBadgeGroupEntity',
    RemoveMapBadgeGroupEntity: 'CourseMap/RemoveBadgeGroupEntity',
    CopyMapBadgeGroupEntities: 'CourseMap/CopyBadgeGroupEntities',
    SetMapElementAsFinal: 'CourseMap/SetElementAsFinal',
    AddEditMapElementBackgroundImage: 'CourseMap/AddEditElementBackgroundImage',
    AddMapArrows: 'CourseMap/AddArrows',
    DeleteMapArrows: 'CourseMap/DeleteArrow',
    EditMapArrowDashed: 'CourseMap/EditArrowDashed',
    EditMapArrowColor: 'CourseMap/EditArrowColor',
    GetStudentReport: 'SimpleClickable/GetStudentReport',


    //Topics
    GetAllTopics: 'Topic/GetAllTopics',
    GetMyTopics: 'Topic/GetMyTopics',
    AddTopic: 'Topic/AddTopic',
    EditTopic: 'Topic/EditTopic',
    AddSubtopic: 'Topic/AddSubtopic',
    EditSubtopic: 'Topic/EditSubtopic',
    DeleteTopic:'Topic/DeleteTopic',
    DeleteSubtopic:'Topic/DeleteSubtopic',
    DeactivateTopic:'Topic/DeactiveTopic',
    DeactivateSubtopic:'Topic/DeactiveSubtopic',

    //Tutorial
    AddTutorial: 'Tutorials/AddTutorial',
    AddEditTutorialThumbnail:'Tutorials/AddEditTutorialThumbnail',
    AddEditTutorialPDF:'Tutorials/AddEditTutorialPDF',
    AddEditTutorialVideo:'Tutorials/AddEditTutorialVideo',

    //Question Group
    AddQuestionsGroupName: 'QuestionGroups/AddQuestionsGroup',
    AddEditQuestionsGroupImage:'QuestionGroups/AddEditQuestionsGroupImage',
    AddQuestionsSubgroup:'QuestionGroups/AddQuestionsSubgroup',
    EditQuestionsSubgroup:'QuestionGroups/EditQuestionsSubgroup',
    AssignQuestionToSubgroup:'QuestionGroups/AssignQuestions',
    DeassignQuestionToSubgroup:'QuestionGroups/DeassignQuestions',
    AddQuestionsGroupName: 'QuestionGroups/AddQuestionsGroup',
    AddQuestionsGroupSingleStep: 'QuestionGroups/AddQuestionsGroupSingleStep',
    EditQuestionsGroupSingleStep: 'QuestionGroups/EditQuestionsGroupSingleStep',
    DeleteQuestionsGroup: 'QuestionGroups/DeleteGroup',
    DeleteQuestionsSubgroup: 'QuestionGroups/DeleteSubgroup',

    //Image Answer Group
    GetImageAnswerGroup: 'ImageAnswers/GetImageAnswerGroup',
    GetImageAnswerGroups: 'ImageAnswers/GetImageAnswerGroups',
    GetMyImageAnswerGroups: 'ImageAnswers/GetMyImageAnswerGroups',
    GetImageAnswerGroups_SIMPLE: 'ImageAnswers/GetImageAnswerGroups_PORTAL_SIMPLE',
    AddImageAnswerGroup: 'ImageAnswers/AddGroup',
    EditImageAnswerGroup: 'ImageAnswers/EditGroup',
    AddImageAnswerName:'ImageAnswers/AddAnswer',
    AddImageAnswerImage:'ImageAnswers/AddEditAnswerImage',
    DeleteImageAnswer:'ImageAnswers/DeleteNode',
    DeleteImageAnswerGroup:'ImageAnswers/DeleteTree',
    AddImageAnswrSingleStep: 'ImageAnswers/AddAnswerImageOneStep',
    EditImageAnswrSingleStep: 'ImageAnswers/EditAnswerImageOneStep',

    //Interpreted Images 
    GetInterpretedImagesGroupList:'InterpretedImages/GetGroups',
    GetMyInterpretedImagesGroupList:'InterpretedImages/GetMyGroups',
    GetInterpretedImagesGroupList_SIMPLE:'InterpretedImages/GetGroups_PORTLA_SIMPLE',
    GetInterpretedImagesGroup: 'InterpretedImages/GetGroup',
    AddInterpretedImagesGroup:'InterpretedImages/AddGroup',
    DeleteInterpretedImagesGroup:'InterpretedImages/DeleteTree',
    EditInterpretedImagesGroup:'InterpretedImages/EditGroup',
    GetInterpretationValues:'InterpretedImages/GetValues',
    AddInterpretedImageCodeValues:'InterpretedImages/AddImageCodeValues',
    AddEditInterpretedImagePicture:'InterpretedImages/AddEditImagePicture',
    AddInterpretedImageSingleStep:'InterpretedImages/AddImageSingleStep',
    DeleteInterpretedImageSingleStep:'InterpretedImages/DeleteNode',
    EditInterpretedImageSingleStep: 'InterpretedImages/EditImageSingleStep',
    EditInterpretedImageName: 'InterpretedImages/EditInterpretedImageName',
    EditInterpretedImagePicture: 'InterpretedImages/EditInterpretedImagePicture',
    EditInterpretedImageValues: 'InterpretedImages/EditInterpretedImageValues',

    //Keyboard
    AddNumericKey:'Keyboard/AddKeyboardNumericKey',
    EditNumericKey:'Keyboard/EditKeyboardNumericKey',
    RemoveKeyboardNumericKey:'Keyboard/RemoveKeyboardNumericKey',

    GetNumericKeys:'Keyboard/GetAllNumericKeys_PORTAL',
    SearchKeys_ADVANCED_PORTAL:'Keyboard/SearchKeys_ADVANCED_PORTAL',
    GetAllKeys:'Keyboard/GetAllKeys',
    GetVariableKeys:'Keyboard/GetAllVariableKeys',
    GetQuestionsSpecificKeyboard:'Keyboard/GetQuestionsSpecificKeyboard',

    AddVariableKey:'Keyboard/AddKeyboardVariableKey',
    EditVariableKey:'Keyboard/EditKeyboardVariableKey',
    RemoveKeyboardVariableKey:'Keyboard/RemoveKeyboardVariableKey',
    RemoveKeyboardVariableKeyImage:'Keyboard/RemoveKeyboardVariableKeyImage',
    AddKeyboardVariableKeyImage:'Keyboard/AddKeyboardVariableKeyImage',
    AddKeyboardKeys:'Keyboard/AddKeyboardKeys',
    RemoveKeyFromKeyboard:'Keyboard/RemoveKeyFromKeyboard',

    AddKeyboardName:'Keyboard/AddKeyboardName',
    AddKeyboard:'Keyboard/AddKeyboard',
    RemoveKeyboard:'Keyboard/RemoveKeyboard',

    EditKeyboardName:'Keyboard/EditKeyboardName',
    AssignNumericKeys:'Keyboard/AssignNumericKeys',
    AssignVariableKeys:'Keyboard/AssignVariableKeys',
    GetAllKeyboards:'Keyboard/GetAllKeyboards',
    GetAllKeyboards_SIMPLE:'Keyboard/GetAllKeyboards_PORTAL_SIMPLE',
    SearchKeyoards_ADVANCED_PORTAL:'Keyboard/SearchKeyoards_ADVANCED_PORTAL',
    SearchKeyoards_ADVANCED_UPDATED_PORTAL:'Keyboard/SearchKeyoards_ADVANCED_UPDATED_PORTAL',
    SearchOwnedKeyoards_ADVANCED_PORTAL:'Keyboard/SearchOwnedKeyoards_ADVANCED_PORTAL',
    GetKeyboard_PORTAL_VIEW_EDIT:'Keyboard/GetKeyboard_PORTAL_VIEW_EDIT',
    SwabKeyboardKeys:'Keyboard/SwabKeyboardKeys',
    MoveAfterKey:'Keyboard/MoveAfterKey',
    EditKeyboardKeysPerRow:'Keyboard/EditKeyboardKeysPerRow',
    GetQuestionsForKeyboardKey:'Keyboard/GetQuestionsForKeyboardKey',

    //KeysLists
    AddKeysLists:'KeysList/AddList',
    SearchKeyLists_ADVANCED_PORTAL:'KeysList/SearchKeyLists_ADVANCED_PORTAL',
    GetAllKeyLists:'KeysList/GetAllKeyLists',
    SearchKeyListAssignedKeys_ADVANCED_PORTAL:'KeysList/SearchKeyListAssignedKeys_ADVANCED_PORTAL',
    GetKeysListId:'KeysList/GetKeysListId',
    UpdateKeyListCode:'KeysList/UpdateCode',

    //Questions
    AddEditSimpleClickableQuestionImage: 'SimpleClickable/AddEditQuestionBackgroundImage',
    AddEditSimpleClickableQuestionPDF: 'SimpleClickable/AddEditQuestionPDF',
    AddEditSimpleClickableQuestionVideo:'SimpleClickable/AddEditQuestionVideo',
    MakeClickablePublic:'SimpleClickable/MakePublic',
    AddSimpleClickableQuestionSingleStep: 'SimpleClickable/AddQuestionSingleStep',
    AddNewQuestionParts: 'SimpleClickable/AddNewQuestionParts',
    EditClickablePartLocation: 'SimpleClickable/EditClickablePartLocation',
    AddEditClickablePartBackgroundImage: 'SimpleClickable/AddEditClickablePartBackgroundImage',
    PostStatistic: 'SimpleClickable/PostStatistic',
    AddQuestionPDFStatistic: 'SimpleClickable/AddQuestionPDFStatistic',
    CopySC_Question: 'SimpleClickable/CopyQuestion',

    AddKeyboardQuestion:'KeyboardQuestion/AddQuestionSingleStep',
    AddEditKeyboardQuestionImage: 'KeyboardQuestion/AddEditQuestionImage',
    AddEditKeyboardQuestionPDF: 'KeyboardQuestion/AddEditQuestionPDF',
    GetQuestionsSearch: 'SimpleClickable/GetQuestions_PORTAL',
    GetQuestionsAdvancedSearch: 'SimpleClickable/GetQuestions_ADVANCED_PORTAL',
    GetQuestionsAdvanced2Search: 'SimpleClickable/GetQuestions_ADVANCED2_PORTAL',
    GetAllQuestionsSearch: 'SimpleClickable/GetAllQuestions_PORTAL',

    GetOwnedQuestionsSearch: 'SimpleClickable/GetQuestionsOwned_PORTAL',
    RemoveQuestionSolution: 'SimpleClickable/RemoveQuestionSolution',
    EditQuestionBaseInfo:'SimpleClickable/EditQuestionBaseInfo',
    GetQuestionClickable:'SimpleClickable/GetQuestion_PORTAL',
    GetQuestionClickablePlay:'SimpleClickable/GetQuestion_APP',
    GetQuestionKeyboard:'KeyboardQuestion/GetQuestion_PORTAL',
    EditQuestionBaseInfo:'SimpleClickable/EditQuestionBaseInfo',
    RemoveClickable:'SimpleClickable/RemoveClickable',
    RemoveQuestion:'SimpleClickable/RemoveQuestion',
    UpdateClickableImageAnswer:'SimpleClickable/UpdateClickableImageAnswer',
    GetQuestionStatisticTotal:'SimpleClickable/GetQuestionStatisticTotal',
    GetQuestionsStatistics:'SimpleClickable/GetQuestionsStatistics',
    GetStudentStatistics:'SimpleClickable/GetStudentStatistics',
    CheckQuestionCodeExists:'SimpleClickable/CheckQuestionCodeExists',

    RemoveQuestionKeyboard:'KeyboardQuestion/RemoveQuestion',
    EditKeyboardQuestionLatex:'KeyboardQuestion/EditQuestionLatex',
    EditQuestionAdditionalInfo:'KeyboardQuestion/EditQuestionAdditionalInfo',
    AddQuestionAnswer:'KeyboardQuestion/AddQuestionAnswer',
    RemoveQuestionAnswer:'KeyboardQuestion/RemoveQuestionAnswer',
    EditQuestionAnswer:'KeyboardQuestion/EditQuestionAnswer',
    GetKeyboardQuestionWrongAnswers_PORTAL:'KeyboardQuestion/GetKeyboardQuestionWrongAnswers_PORTAL',

    GetQuestionMultipleChoice:'MultipleChoiceQuestion/GetQuestion_PORTAL',
    AddMultipleChoiceQuestion:'MultipleChoiceQuestion/AddQuestionSingleStep',
    AddEditMultipleQuestionImage: 'MultipleChoiceQuestion/AddEditQuestionImage',
    AddEditMultipleQuestionPDF: 'MultipleChoiceQuestion/AddEditQuestionPDF',
    EditMultipleQuestionLatex:'MultipleChoiceQuestion/EditQuestionLatex',
    EditMultipleQuestionAdditionalInfo:'MultipleChoiceQuestion/EditQuestionAdditionalInfo',
    AddMultipleQuestionAnswer:'MultipleChoiceQuestion/AddQuestionAnswer',
    EditMultipleQuestionAnswer:'MultipleChoiceQuestion/EditQuestionAnswer',
    RemoveMultipleQuestionAnswerImage:'MultipleChoiceQuestion/RemoveQuestionAnswerImage',
    RemoveMultipleQuestionAnswerLatex:'MultipleChoiceQuestion/RemoveQuestionAnswerLatex',
    EditMultipleQuestionColumnsPerRow:'MultipleChoiceQuestion/EditQuestionColumnsPerRow',

    RemoveMultipleQuestionAnswer:'MultipleChoiceQuestion/RemoveQuestionAnswer',
    RemoveMultipleQuestion:'MultipleChoiceQuestion/RemoveQuestion',

    AddEnergyBalanceQuestionSingleStep:'EnergyBalanceQuestion/AddQuestionSingleStep',
    RemoveEnergyBalanceQuestion:'EnergyBalanceQuestion/RemoveQuestion',
    GetEnergyBalanceQuestion:'EnergyBalanceQuestion/GetQuestion_PORTAL',
    AddEditEnergyBalanceQuestionGeneralLatex: 'EnergyBalanceQuestion/EditGeneralLatex',
    AddEditEnergyBalanceQuestionFluxesLatex: 'EnergyBalanceQuestion/EditFluxesLatex',
    AddEditEnergyBalanceQuestionLabelLatex: 'EnergyBalanceQuestion/EditLabelLatex',
    AddEditEnergyBalanceQuestionQuestionLatex: 'EnergyBalanceQuestion/EditQuestionLatex',
    AddEditEnergyBalanceQuestionQuestionCode: 'EnergyBalanceQuestion/EditQuestionCode',
    AddEditEnergyBalanceQuestionImage: 'EnergyBalanceQuestion/AddEditQuestionImage',
    EditEnergyBalanceQuestionQuestionAnswer: 'EnergyBalanceQuestion/EditQuestionAnswer',
    AddEnergyBalanceQuestionQuestionAnswer: 'EnergyBalanceQuestion/AddQuestionAnswer',
    AddEnergyBalanceQuestionLabel: 'EnergyBalanceQuestion/AddQuestionLabel',
    AddEnergyBalanceQuestionRelation: 'EnergyBalanceQuestion/AddRelation',
    RemoveEnergyBalanceQuestionLabel: 'EnergyBalanceQuestion/RemoveLabel',
    RemoveEnergyBalanceQuestionRelation: 'EnergyBalanceQuestion/RemoveRelation',
    RemoveEnergyBalanceQuestionAnswer: 'EnergyBalanceQuestion/RemoveAnswer',
    RemoveEnergyBalanceQuestionQuestioneer: 'EnergyBalanceQuestion/RemoveQuestioneer',
    AddEnergyBalanceQuestionQuestion: 'EnergyBalanceQuestion/AddNewQuestion',
    DummyUnDummyLabelEnergyBalanceQuestionLabel: 'EnergyBalanceQuestion/DummyUnDummyLabel',
    FlipEnergyBalanceQuestionQuestion: 'EnergyBalanceQuestion/FlipQuestion',


    //Question Relations
    GetMultipleChoiceQuestionRelations:'MultipleChoiceQuestion/GetQuestionSeriesMapRelations_PORTAL',
    GetKeyboardQuestionRelations:'KeyboardQuestion/GetQuestionSeriesMapRelations_PORTAL',
    GetClickableQuestionRelations:'SimpleClickable/GetQuestionSeriesMapRelations_PORTAL',

    //Question Relations
    GetQuestionComments:'QuestionComments/GetQuestionComments',
    SearchComments:'QuestionComments/GetComments',
    GetUnseenCommentsNumber:'QuestionComments/GetUnseenCommentsNumber',
    AddQuestionComment:'QuestionComments/AddQuestionComment',
    RegisterSeenNotification:'QuestionComments/RegisterSeenNotification',

    //Question Series
    SearchSeriesAdvanced: 'QuestionSeries/SearchSeries_ADVANCED',
    SearchOwnedSeriesAdvanced: 'QuestionSeries/SearchSeries_OWNED_ADVANCED',
    GetSeriesByCode: 'QuestionSeries/GetSeries',
    GetSeriesByCodeEXTENDED: 'QuestionSeries/GetSeries_EXTENDED',
    GetSeriesId_EXTENDED: 'QuestionSeries/GetSeriesId_EXTENDED',
    GetSeriesAdders: 'QuestionSeries/GetSeriesAdders',

    GetAllSeriesByCode: 'QuestionSeries/GetAllSeriesByCode',
    GetMySeries: 'QuestionSeries/GetMySeries',
    AddSeries:'QuestionSeries/AddSeries',
    EditSeriesCode:'QuestionSeries/EditSeriesCode',
    DecreasePoolsNumberSeries:'QuestionSeries/DecreasePoolsNumber',
    IncreasePoolsNumbersSeries:'QuestionSeries/IncreasePoolsNumber',
    IncreasePoolNumberSeriesElement:'QuestionSeries/IncreaseElementPool',
    DecreasePoolNumberSeriesElement:'QuestionSeries/DecreaseElementPool',
    AssignElementsToPoolSeries:'QuestionSeries/AssignElementsToPool',
    DeleteSeries:'QuestionSeries/DeleteSeries',
    DeselectElementSeries:'QuestionSeries/DeselectElementSeries',
    ActionElements:'QuestionSeries/ActionElements',
    AddSeriesElements:'QuestionSeries/AddSeriesElements',
    AddSeriesStatistic:'QuestionSeries/AddStatistic',

    //Approval
    GetToBeApprovedClickableQuestions: 'SimpleClickable/GetToBeApprovedQuestions',
    ApproveClickableQuestion:'SimpleClickable/ApproveQuestion',

    //Challenges
    AddChallengeTemplate:'QuestionChallenge/AddTemplate',
    GetAllChallenges:'QuestionChallenge/GetAllTemplates',
    RemoveChallengeTemplate:'QuestionChallenge/RemoveTemplate',
    EditChallengeTemplateCode:'QuestionChallenge/EditTemplateCode',
    EditChallengeTemplateTiming:'QuestionChallenge/EditTemplateTiming',
    AssignChallengeTemplateQuestion:'QuestionChallenge/AssignNewQuestion',
    DeassignChallengeTemplateQuestion:'QuestionChallenge/DeassignNewQuestion',
    RearrangeChallengeTemplateQuestion:'QuestionChallenge/RearrangeQuestion',

    //Sessions
    AddSession:'QuestionChallenge/AddSession',
    EndSession:'QuestionChallenge/EndSession',
    GetAllSessions:'QuestionChallenge/GetAllSessions',


    //Ownership
    EditOwnership:'Ownership/EditOwnership',

    //Key Share
    ShareKeyAdd: 'KeyShare/ShareKey',
    ShareKeyGetMyKeys: 'KeyShare/GetMyReceivedKeys',
    ShareKeyApproveKey: 'KeyShare/ApproveKey',
    SetKeyOnDevice: 'KeyShare/SetKeyOnDevice',

    //Student feedback
    Feedback_ReferenceQuestion: 'Feedback/ReferenceQuestion',
    Feedback_AddStudentFeedback: 'Feedback/AddStudentFeedback',
    Feedback_SearchFeedback: 'Feedback/DecryptObject',
    Feedback_GetQuestionFeedback: 'Feedback/GetQuestionFeedback',
    Feedback_GetQuestionsFeedback: 'Feedback/GetFeedback',

    //Default Question Images
    AddDefaultQuestionImage: 'QuestionImage/AddImage',
    DeleteDefaultQuestionImage: 'QuestionImage/DeleteImage',
    EditDefaultQuestionImageCode: 'QuestionImage/EditCode',
    EditDefaultQuestionImage: 'QuestionImage/EditImage',
    SearchDefaultQuestionImage: 'QuestionImage/SearchDefaultQuestionImages_ADVANCED_PORTAL',

}

const GetRoute = (Title) => `${Server}${Routes[Title]}`

axios.interceptors.request.use(function (config) {

    /*let token = localStorage.getItem('token')

    console.log('new request')
    console.log(token)

    if(token){
        axios.defaults.headers.common['Authorization'] = 'bearer ' + token
    }
    else{
        axios.defaults.headers.common['Authorization'] = null
    }*/

    return config
});

export const LoginHTTPRequest_API = (Username, Password) => {

   return axios.post(GetRoute('Login'), {
       username: Username,
       password: Password
   }).then(data => {
        return {
            data: data,
            Code: 200
        }
   }).catch(error => {
    return {
        message: !error.response ? error.message : error.response.data,
        Code:  !error.response ? 400 : error.response.status
    }
   })
}

//GET
export const GET_REQUEST_PARAMETER_API = (Path, Value = null) => {
    
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')

    let data_pool_id = localStorage.getItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG') 

    console.log("data_pool_id")
    console.log(data_pool_id)

    return axios.get(Value ? `${Route}/${Value}` : `${Route}`,
      {
        headers: {
            'Authorization': token ? 'bearer ' + token : ''
          }
      })
    .then(data => { 
        return {
            data: data,
            Code: 200
        }
    }).catch(error => {
        console.log(error)

        return {
            message: !error.response ? error.message : error.response.data,
            Code:  !error.response ? 400 : error.response.status
        }
    })
 }

 export const GET_REQUEST_DATA_POOL_PARAMETER_API = (Path, Value = null) => {
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')

    let data_pool_id = localStorage.getItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG') 

    console.log("data_pool_id")
    console.log(data_pool_id)

    return axios.get(Value ? `${Route}/${Value}/${data_pool_id}` : `${Route}/${data_pool_id}`,
      {
        headers: {
            'Authorization': token ? 'bearer ' + token : ''
          }
      })
    .then(data => { 
        return {
            data: data,
            Code: 200
        }
    }).catch(error => {
        console.log(error)

        return {
            message: !error.response ? error.message : error.response.data,
            Code:  !error.response ? 400 : error.response.status
        }
    })
 }

 export const GET_REQUEST_BODY_API = (Path, Body) => {
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')

    let data_pool_id = localStorage.getItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG') 

    console.log("data_pool_id")
    console.log(data_pool_id)

    return axios.post(Route,
    {
        ...Body,
        DataPoolId: data_pool_id
    },
    {
        headers: {
            'Authorization': token ? 'bearer ' + token : ''
          }
      })
    .then(data => { 
        return {
            data: data,
            Code: 200
        }
    }).catch(error => {
        console.log(error)
        return {
            Code: 400
        }
    })
 }

 //ADD
 export const ADD_REQUEST_BODY_API = (Path, Body) => {
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')

    let data_pool_id = localStorage.getItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG') 

    console.log("data_pool_id")
    console.log(data_pool_id)
    
    return axios.post(Route, 
    {
        ...Body,
        DataPoolId: data_pool_id
    },
    {
        headers: {
            'Authorization': token ? 'bearer ' + token : ''
          }
      })
    .then(data => { 
        return {
            data: data,
            Code: 200
        }
    }).catch(error => {
        console.log(error)
        console.log(error.response)

        return {
            message: error.response ? error.response.data + " - " + error.response.status : error.message,
            Code: 400
        }
    })
 }

 export const ADD_REQUEST_FILE_API = (Path, FileData) => {
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')

    let data_pool_id = localStorage.getItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG') 

    console.log("data_pool_id")
    console.log(data_pool_id)

    FileData.append('DataPoolId', data_pool_id)

    return axios.post(Route, 
        FileData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': token ? 'bearer ' + token : ''
              }
          })
        .then(data => { 
            return {
                data: data,
                Code: 200
            }
        }).catch(error => {
            console.log(error)
            console.log(error.response)
    
            return {
                message: error.response ? error.response.data + " - " + error.response.status : error.message,
                Code: 400
            }
        })

    /*return axios({
        method: 'post',
        url: Route,
        data: FileData,
        config: { headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
         }}
        })
        .then(data => { 
            return {
                data: data,
                Code: 200
            }
        }).catch(error => {
            return {
                message: error.response ? error.response.data + " - " + error.response.status : error.message,
                Code: 400
            }
        })*/
 }

//EDIT
 export const EDIT_REQUEST_BODY_API = (Path, Body) => {
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')

    return axios.put(Route, 
    {
        ...Body
    },
    {
        headers: {
            'Authorization': token ? 'bearer ' + token : ''
          }
      })
    .then(data => { 
        return {
            data: data,
            Code: 200
        }
    }).catch(error => {
        console.log(error)
        return {
            Code: 400
        }
    })
 }

 export const EDIT_REQUEST_FILE_API = (Path, FileData) => {
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')


    return axios({
        method: 'put',
        url: Route,
        data: FileData,
        config: { headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': token ? 'bearer ' + token : ''
         }}
        })
        .then(data => { 
            return {
                data: data,
                Code: 200
            }
        }).catch(error => {
            console.log(error)
            return {
                Code: 400
            }
        })
 }

 //DELETE
 export const DELETE_REQUEST_PARAMETER_API = (Path, Value) => {
    let Route = `${Server}${Path}`

    let token = localStorage.getItem('token')


    return axios.delete(`${Route}/${Value}`,
    {
        headers: {
            'Authorization': token ? 'bearer ' + token : ''
          }
      })
    .then(data => { 
        return {
            data: data,
            Code: 200
        }
    }).catch(error => {
        console.log(error)
        return {
            Code: 400
        }
    })
 }




